import { render, staticRenderFns } from "./ZohoLeadsSection.vue?vue&type=template&id=639b9a81&scoped=true"
import script from "./ZohoLeadsSection.vue?vue&type=script&lang=js"
export * from "./ZohoLeadsSection.vue?vue&type=script&lang=js"
import style0 from "./ZohoLeadsSection.vue?vue&type=style&index=0&id=639b9a81&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639b9a81",
  null
  
)

export default component.exports